<template>
	<v-row class="fill-height">
		<!-- <v-col cols="12"  class="d-flex flex-wrap" >
			<v-card v-for="(item,index) in dayData" :color="item.color" dark style="width: 300px; margin-right: 10px; margin-bottom: 10px;">
				<v-card-title class="text-h5">
					{{item.title}}
				</v-card-title>
				<v-card-subtitle>
					{{item.subTitle}}
				</v-card-subtitle>
				<v-card-text class="text-h3">
					{{item.content}}
				</v-card-text>
			</v-card>
			
			
		</v-col>
		<v-col cols="12"  class="d-flex flex-wrap">
			<v-card v-for="(item,index) in weekData" :color="item.color" dark style="width: 300px; margin-right: 10px;">
				<v-card-title class="text-h5">
					{{item.title}}
				</v-card-title>
				<v-card-subtitle>
					{{item.subTitle}}
				</v-card-subtitle>
				<v-card-text class="text-h2">
					{{item.content}}
				</v-card-text>
			</v-card>
		</v-col>
		<v-col cols="12"  class="d-flex flex-wrap">
			<v-card v-for="(item,index) in monthData" :color="item.color" dark style="width: 300px; margin-right: 10px;">
				<v-card-title class="text-h5">
					{{item.title}}
				</v-card-title>
				<v-card-subtitle>
					{{item.subTitle}}
				</v-card-subtitle>
				<v-card-text class="text-h2">
					{{item.content}}
				</v-card-text>
			</v-card>
		</v-col> -->
	</v-row>

</template>

<script>
	export default {
		name: "dashboard",
		data() {
			return {
				
			}
		},
		mounted() {
			

		},
		methods: {
			

		},

	}
</script>
